import {
  TASK_ERROR,
  GET_TASK,
  EDIT_TASK_FAILED,
  TASK_RESET,
  EDIT_TASK_SUCCESS,
} from "../constants/taskConstants";

const initialState = {
  task: null,
  loading: true,
};

export const requestTask = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_TASK:
      return Object.assign({}, state, {
        task: action.payload,
        loading: false,
      });
    case TASK_ERROR:
      return Object.assign({}, state, { error: action.payload });
    case TASK_RESET: {
      return Object.assign({}, state, {
        task: null,
        loading: true,
      });
    }
    default:
      return state;
  }
};

export const editTask = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_TASK_SUCCESS:
      return Object.assign({}, state, {
        task: action.payload,
      });
    case EDIT_TASK_FAILED:
      return Object.assign({}, state, {
        error: action.payload,
      });
    default:
      return state;
  }
};
